import axios from 'axios'
import Config from '@/config.js'
import moment from 'moment'

export default class BaseService {
  constructor (entity) {
    this.entity = entity
    this.apis = {
      getAll: (query) => axios.get(Config.API.BPIURL + `/${entity}`, { params: query }),
      add: (payload) => axios.post(Config.API.BPIURL + `/${entity}`, payload),
      edit: (id, payload) => axios.put(Config.API.BPIURL + `/${entity}/${id}`, payload),
      delete: (id) => axios.delete(Config.API.BPIURL + `/${entity}/${id}`),
      inActivate: (id) => axios.post(Config.API.BPIURL + `/${entity}/${id}/inactivate`),
      batchUpdateSort: (payload) => axios.post(Config.API.BPIURL + `/${entity}-sorting`, payload)
    }

    // fake data
    if (Config.useFakeData) {
      this.apis = Object.assign(this.apis, {
        getAll: () => new Promise((resolve, reject) => {
          var res = {
            data: {
              status: 'ok',
              result: []
            }
          }
          resolve(res)
        })
      })
    }
  }

  fetchData (vm) {
    return new Promise((resolve, reject) => {
      if (vm.$store.state[this.entity].isFetching) {
        var timer = setInterval(() => {
          if (vm.$store.state[this.entity].isFetching) return
          clearInterval(timer)
          if (vm.$store.state[this.entity].isFetched) {
            resolve(vm.$store.state[this.entity].list)
          } else {
            reject(new Error('無法取得資料，請嘗試重新整理'))
          }
        }, 500)
        return
      }
      vm.$store.state[this.entity].isFetching = true
      var query = null
      if (vm.$store.state[this.entity].lastFetchedAt) {
        query = { from: vm.$store.state[this.entity].lastFetchedAt }
      }
      return this.getAll(vm, query)
        .then(res => {
          let dataList = res.data.data || []
          if (!vm.$store.state[this.entity].list || !vm.$store.state[this.entity].list.length) {
            vm.$store.state[this.entity].list = dataList
          } else {
            for (let data of dataList) {
              let idx = vm.$store.state[this.entity].list.findIndex(o => o.ID === data.ID)
              if (idx >= 0) {
                vm.$set(vm.$store.state[this.entity].list, idx, data)
              } else {
                vm.$store.state[this.entity].list.push(data)
              }
            }
          }

          vm.$store.state[this.entity].isFetched = true
          vm.$store.state[this.entity].fecthedAt = true
          vm.$store.state[this.entity].isReloaded = false
          vm.$store.state[this.entity].isFetching = false
          vm.$store.state[this.entity].lastFetchedAt = moment().format('YYYY-MM-DD HH:mm:ssZ')
          return res
        })
        .then(res => {
          resolve()
          return res
        })
        .catch(err => {
          vm.$store.state[this.entity].isFetching = false
          reject(err)
        })
    })
  }

  getAll (vm, query) {
    vm.setLoading(`Service<${this.entity}>.getAll`, true)
    return this.apis.getAll(query)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.setLoading(`Service<${this.entity}>.getAll`, false)
      })
  }

  add (vm, payload) {
    vm.setLoading(`Service<${this.entity}>.add`, true)
    return this.apis.add(payload)
      .then(res => {
        let ok = res && (
          res.status === 201 || (res.data && !res.data.error)
        )
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.setLoading(`Service<${this.entity}>.add`, false)
      })
  }

  edit (vm, id, payload) {
    vm.setLoading(`Service<${this.entity}>.edit`, true)
    return this.apis.edit(id, payload)
      .then(res => {
        let ok = res && (
          res.status === 204 || (res.data && !res.data.error)
        )
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.setLoading(`Service<${this.entity}>.edit`, false)
      })
  }

  delete (vm, id) {
    vm.setLoading(`Service<${this.entity}>.delete`, true)
    return this.apis.delete(id)
      .then(res => {
        let ok = res && (
          res.status === 204 || (res.data && !res.data.error)
        )
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.setLoading(`Service<${this.entity}>.delete`, false)
      })
  }

  inActivate (vm, id) {
    vm.setLoading(`Service<${this.entity}>.inActivate`, true)
    return this.apis.inActivate(id)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.setLoading(`Service<${this.entity}>.inActivate`, false)
      })
  }

  batchUpdateSort (vm, payload) {
    vm.setLoading(`Service<${this.entity}>.batchUpdateSort`, true)
    return this.apis.batchUpdateSort(payload)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.setLoading(`Service<${this.entity}>.batchUpdateSort`, false)
      })
  }
}
